module.exports = __webpack_public_path__ + "img/ic_switch_on.f0279dae.png";